import React from "react";
import { Col, Row } from "react-bootstrap";

const AboutChild_Experise = (props) => {
  let Int_Array = [
    // "Full-Stack Development",
    "Multi-Platform Compatibility",
    "Agile Project Management",
    "Process Automation",
    "Workflow Streamlining",
    "User Experience Research",
  ];

  return (
    <>
      <h2 className="m-0 pb-3">My Expertise</h2>
      <hr />
      {Int_Array?.map((item, index) => (
        <>
          <Row className="py-2">
            <Col md={12}>
              <h6 className="m-0 title-primary">{item}</h6>
            </Col>
          </Row>
          <hr />
        </>
      ))}
    </>
  );
};

export default AboutChild_Experise;
